// extracted by mini-css-extract-plugin
export var cardIcon = "_b8-4";
export var checkboxCard = "_b8-0";
export var checkboxCardSelected = "_b8-3";
export var disabled = "_b8-1";
export var outerBorder = "_b8-2";
export var spacerMedium = "_b8-7";
export var spacerSmall = "_b8-6";
export var spacerXsmall = "_b8-5";